function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectorTechnical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "32px",
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(-4 4)",
    id: "linearGradient1163"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d2d2d2",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm0 2a6 6 0 0 1 6 6 6 6 0 0 1-6 6 6 6 0 0 1-6-6 6 6 0 0 1 6-6z",
    style: {
      opacity: 1,
      fill: "white",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14.370387,
    x: 7,
    y: -15,
    transform: "rotate(90)",
    style: {
      opacity: 1,
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14.370387,
    x: 9.7678213,
    y: -4.1643934,
    transform: "rotate(30)",
    style: {
      opacity: 1,
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14.370387,
    x: 1.7678211,
    y: 3.6504133,
    transform: "rotate(-30)",
    style: {
      opacity: 1,
      fill: "white"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorTechnical);
export default __webpack_public_path__ + "static/media/sectorTechnical.89c231317b67ac2692175658912685f9.svg";
export { ForwardRef as ReactComponent };